import { PARTNERS } from "../lib/constants";
import { Reveal } from "./motion";

export default function Partners() {
  // Duplicate the list for seamless infinite marquee
  const list = [...PARTNERS, ...PARTNERS];
  return (
    <section
      id="aliados"
      data-testid="partners-section"
      className="border-y border-slate-200 bg-white py-20 lg:py-24"
    >
      <div className="mx-auto mb-12 max-w-7xl px-5 lg:px-8">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <Reveal>
            <div className="overline mb-3 text-pv-orange">Marcas Aliadas</div>
            <h2 className="font-display text-3xl font-extrabold tracking-tight text-pv-green sm:text-4xl">
              Trabajamos con los líderes mundiales en seguridad.
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="max-w-sm text-sm text-slate-500">
              Marcas certificadas internacionalmente, con respaldo técnico y
              disponibilidad continua.
            </p>
          </Reveal>
        </div>
      </div>

      {/* Slow editorial marquee row */}
      <div className="relative overflow-hidden">
        <div className="pointer-events-none absolute bottom-0 left-0 top-0 z-10 w-32 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute bottom-0 right-0 top-0 z-10 w-32 bg-gradient-to-l from-white to-transparent" />
        <div className="flex w-max items-center gap-16 px-5 animate-marquee-slow lg:gap-24">
          {list.map((p, i) => (
            <div
              key={`${p.name}-${i}`}
              data-testid={`partner-${p.name.toLowerCase().replace(/\s+/g, "-")}-${i}`}
              className="flex h-14 shrink-0 items-center justify-center lg:h-16"
              title={p.name}
            >
              <img
                src={p.logo}
                alt={`${p.name} logo`}
                loading="lazy"
                className="h-full w-auto max-w-[180px] object-contain opacity-70 grayscale transition-all duration-300 hover:opacity-100 hover:grayscale-0"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Static grid as accessible fallback / desktop secondary view */}
      <div className="mx-auto mt-12 max-w-7xl px-5 lg:px-8">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-sm border border-slate-200 bg-slate-200 sm:grid-cols-4 lg:grid-cols-8">
          {PARTNERS.map((p) => (
            <div
              key={p.name}
              className="group flex aspect-[3/2] items-center justify-center bg-white p-5 transition-colors hover:bg-slate-50"
              title={p.name}
            >
              <img
                src={p.logo}
                alt={`${p.name} logo`}
                loading="lazy"
                className="max-h-10 w-auto object-contain opacity-60 grayscale transition-all duration-300 group-hover:opacity-100 group-hover:grayscale-0 lg:max-h-12"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
